<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      :validate-on-rule-change="false"
      size="mini"
    >
      <h6 style="color: #101010">
        {{ $l('form_label_base') || '基本信息' }}
      </h6>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_salesPerson') || '业务人员'"
            prop="salesPersonCode"
          >
            <dict-select
              v-model="formData.salesPersonCode"
              :selectedLabel.sync="formData.salesPersonName"
              url="/master/common/dict/baseUserSelect"
              :placeholder="$l('please_label_salesPerson') || '请选择业务人员'"
              size="mini"
              filterable
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_cust') || '客户'"
            prop="custCode"
          >
            <dict-select
              v-model="formData.custCode"
              url="/master/common/dict/customerSelectByStatus"
              :body="{ dictType: ['W', 'P', 'B', 'Y'] }"
              :placeholder="$l('please_label_cust') || '请选择客户'"
              :selectedLabel.sync="formData.custName"
              filterable
              clearable
              size="mini"
              style="width: 100%"
              @change="custChange"
              :disabled="!!custCode"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_requestDate') || '安排日期'"
            prop="requestDate"
          >
            <el-date-picker
              v-model="formData.requestDate"
              :placeholder="$l('please_label_requestDate') || '请选择安排日期...'"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_deliveryDate') || '快递日期'">
            <el-date-picker
              v-model="formData.deliveryDate"
              :placeholder="$l('please_label_deliveryDate') || '请选择快递日期...'"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_signDate') || '签收日期'">
            <el-date-picker
              v-model="formData.signDate"
              :placeholder="$l('please_label_signDate') || '请选择签收日期...'"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_custContact') || '客户联系人'"
            prop="custContact"
          >
            <el-input
              v-model="formData.custContact"
              :placeholder="$l('please_label_custContact') || '请输入客户联系人...'"
              :maxlength="50"
              show-word-limit
              clearable
            >
              <el-button
                slot="append"
                icon="el-icon-finished"
                @click="custContactChange(formData.custCode)"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_custContactPhone') || '客户联系人电话'"
          >
            <el-input
              v-model="formData.custContactPhone"
              :placeholder="$l('please_label_custContactPhone') || '请输入客户联系人电话...'"
              :maxlength="50"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_custContactEmail') || '客户联系人邮箱'"
          >
            <el-input
              v-model="formData.custContactEmail"
              :placeholder="$l('please_label_custContactEmail') || '请输入客户联系人邮箱...'"
              :maxlength="50"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_sendSampleType') || '样品类型'"
            prop="sendSampleType"
          >
            <dict-select
              v-model="formData.sendSampleType"
              url="/master/common/dict/biz"
              :body="{ dictType: 'sampleSource' }"
              :placeholder="$l('please_label_sendSampleType') || '请选择样品类型...'"
              filterable
              clearable
              size="mini"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_custProjectNo') || '客户项目号'">
            <el-input
              v-model="formData.custProjectNo"
              :placeholder="$l('please_label_custProjectNo') || '请输入客户项目号...'"
              :maxlength="500"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>

      <h6 style="color: #101010" class="my-2">
        {{ $l('form_label_consigneesInfo') || '收货信息' }}
      </h6>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_consignees') || '样品收货人'"
            prop="consignees"
          >
            <el-input
              v-model="formData.consignees"
              :placeholder="$l('please_label_consignees') || '请输入样品收货人...'"
              :maxlength="50"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_consigneesPhone') || '收货人电话'"
            prop="consigneesPhone"
          >
            <el-input
              v-model="formData.consigneesPhone"
              :placeholder="$l('please_label_consigneesPhone') || '请输入收货人电话...'"
              :maxlength="50"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item
            :label="$l('form_label_deliveryAddress') || '样品收货地址'"
            prop="deliveryAddress"
          >
            <el-input
              v-model="formData.deliveryAddress"
              :placeholder="$l('please_label_deliveryAddress') || '请输入样品收货地址...'"
              :maxlength="500"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_sendSampleRemark') || '备注说明'"
          >
            <el-input
              v-model="formData.sendSampleRemark"
              :placeholder="$l('please_label_sendSampleRemark') || '请输入备注说明...'"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 5 }"
              :maxlength="500"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>

      <h6 style="color: #101010" class="my-2">
        {{ $l('form_label_deliveryInfo') || '快递信息' }}
      </h6>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_deliveryPerson') || '发货处理人'"
            prop="deliveryPersonCode"
          >
            <dict-select
              v-model="formData.deliveryPersonCode"
              :selectedLabel.sync="formData.deliveryPersonName"
              url="/master/common/dict/baseUserSelect"
              :placeholder="$l('please_label_deliveryPerson') || '请选择发货处理人...'"
              size="mini"
              filterable
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_deliveryScm') || '快递公司'"
            prop="deliveryScmCode"
          >
            <dict-select
              v-model="formData.deliveryScmCode"
              :selectedLabel.sync="formData.deliveryScmName"
              url="logistics/api/company/select"
              :placeholder="$l('please_label_deliveryScm') || '请选择快递公司...'"
              filterable
              clearable
              size="mini"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('form_label_deliveryNo') || '快递单号'">
            <el-input
              v-model="formData.deliveryNo"
              :placeholder="$l('please_label_deliveryNo') || '请输入快递单号...'"
              :maxlength="50"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_totalQty') || '样品总数量'">
            <el-input v-model="formData.totalQty" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_totalCtnQty') || '总箱数'">
            <el-input-number
              v-model="formData.totalCtnQty"
              :placeholder="$l('please_label_totalCtnQty') || '请输入总箱数...'"
              :min="0"
              :precision="0"
              :controls="false"
              class="w-100"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_totalWeight') || '总重量'">
            <el-input-number
              v-model="formData.totalWeight"
              :placeholder="$l('please_label_totalWeight') || '请输入总重量...'"
              :min="0"
              :step="0.01"
              :precision="2"
              :controls="false"
              class="w-100"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_totalVolume') || '总体积'">
            <el-input-number
              v-model="formData.totalVolume"
              :placeholder="$l('please_label_totalVolume') || '请输入总体积...'"
              :min="0"
              :step="0.01"
              :precision="2"
              :controls="false"
              class="w-100"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_freightFee') || '快递费'">
            <el-input-number
              v-model="formData.freightFee"
              :placeholder="$l('please_label_freightFee') || '请输入快递费...'"
              :min="0"
              :step="0.01"
              :precision="2"
              :controls="false"
              class="w-100"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_insurance') || '运费险'">
            <el-input-number
              v-model="formData.insurance"
              :placeholder="$l('please_label_insurance') || '请输入运费险...'"
              :min="0"
              :step="0.01"
              :precision="2"
              :controls="false"
              class="w-100"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_totalAmount') || '费用合计'">
            <el-input v-model="totalAmount" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_currencyUnit') || '货币单位'"
            prop="currencyUnit"
          >
            <dict-select
              v-model="formData.currencyUnit"
              url="/master/common/dict/biz"
              :body="{ dictType: 'currencyUnit' }"
              :placeholder="$l('please_label_currencyUnit') || '请选择货币单位'"
              filterable
              clearable
              size="mini"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_expensePayerCode') || '付款公司'"
            prop="expensePayerCode"
          >
            <dict-select
              v-model="formData.expensePayerCode"
              :selectedLabel.sync="formData.expensePayerName"
              url="/master/common/dict/biz"
              :body="{ dictType: 'expensePayer' }"
              :placeholder="$l('please_label_expensePayer') || '请选择付款公司'"
              filterable
              clearable
              size="mini"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_dep') || '费用分摊部门'"
            prop="depCode"
          >
            <dep-cascader
              size="mini"
              :lastValue.sync="formData.depCode"
              :valueString.sync="formData.displayDepCode"
              :pathLabels.sync="formData.orgDepFullName"
              :placeholder="$l('please_label_dep') || '请选择费用分摊部门...'"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <ChooseCustomerContacts
      :visible.sync="chooseCustomerContactsVisible"
      :title="`${formData.custName} ${$l('dialog_title_contacts') || '联系人'}`"
      :custCode="formData.custCode"
      @confirm="customerContactsConfirm"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { add, format } from '@/libs/util.number.js'
import dayjs from 'dayjs'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import ChooseCustomerContacts from '@/views/digital/components/choose-customer-contacts'
export default {
  components: { ChooseCustomerContacts },
  mixins: [EditLoading],
  props: {
    sendSampleCode: { type: String, default: '' },
    custCode: { type: String, default: '' },
    custName: { type: String, default: '' },
    sampleData: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      formData: {
        salesPersonCode: '',
        salesPersonName: '',
        requestDate: dayjs().format('YYYY-MM-DD'),
        custContact: '',
        custContactPhone: '',
        custContactEmail: '',
        totalQty: 0,
        // totalCtnQty: 0,
        // totalWeight: 0,
        // totalVolume: 0,
        // freightFee: 0,
        // insurance: 0,
        // totalAmount: 0,
        currencyUnit: 'CNY',
        custCode: '',
      },
      rules: {
        salesPersonCode: [
          {
            required: true,
            message: this.$l('please_label_salesPerson') || '请选择业务人员',
            trigger: 'change',
          },
        ],
        custCode: [
          {
            required: true,
            message: this.$l('please_label_cust') || '请选择客户',
            trigger: 'change',
          },
        ],
        requestDate: [
          {
            required: true,
            message: this.$l('please_label_requestDate') || '请选择安排日期...',
            trigger: 'change',
          },
        ],
        custContact: [
          {
            required: true,
            message: this.$l('please_label_custContact') || '请输入客户联系人...',
            trigger: 'blur',
          },
        ],
        sendSampleType: [
          {
            required: true,
            message: this.$l('please_label_sendSampleType') || '请选择样品类型...',
            trigger: 'change',
          },
        ],
        consignees: [
          {
            required: true,
            message: this.$l('please_label_consignees') || '请输入样品收货人...',
            trigger: 'blur',
          },
        ],
        consigneesPhone: [
          {
            required: true,
            message: this.$l('please_label_consigneesPhone') || '请输入收货人电话...',
            trigger: 'blur',
          },
        ],
        deliveryAddress: [
          {
            required: true,
            message: this.$l('please_label_deliveryAddress') || '请输入样品收货地址...',
            trigger: 'blur',
          },
        ],
        deliveryPersonCode: [
          {
            required: true,
            message: this.$l('please_label_deliveryPerson') || '请选择发货处理人...',
            trigger: 'change',
          },
        ],
        deliveryScmCode: [
          {
            required: true,
            message: this.$l('please_label_deliveryScm') || '请选择快递公司...',
            trigger: 'change',
          },
        ],
        currencyUnit: [
          {
            required: true,
            message: this.$l('please_label_currencyUnit') || '请选择货币单位',
            trigger: 'change',
          },
        ],
        expensePayerCode: [
          {
            required: true,
            message: this.$l('please_label_expensePayer') || '请选择付款公司',
            trigger: 'change',
          },
        ],
        depCode: [
          {
            required: true,
            message: this.$l('please_label_dep') || '请选择费用分摊部门',
            trigger: 'change',
          },
        ],
      },
      chooseCustomerContactsVisible: false,
    }
  },
  computed: {
    ...mapState('admin/user', { userInfo: 'info' }),
    totalAmount() {
      const { freightFee, insurance } = this.formData
      return format(add(freightFee, insurance)) || '0'
    },
  },
  watch: {
    userInfo: {
      handler() {
        if (this.sendSampleCode) return
        if (!this.userInfo) return
        const { userCode, userName, userNameEn } = this.userInfo || {}
        this.formData.salesPersonCode = userCode || ''
        this.formData.salesPersonName = [userNameEn, userName]
          .filter(Boolean)
          .join('-')
      },
      immediate: true,
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (this.custCode && !this.sendSampleCode) {
        this.formData.custCode = this.custCode
        this.formData.custName = this.custName
        this.custChange(this.custCode)
      }
      if (!this.sendSampleCode) return
      const data = await this.$api
        .customerSendSampleDetailApi({ sendSampleCode: this.sendSampleCode })
        .then((res) => res.body)
        .catch(() => null)
      if (!data) return
      this.formData = data
      this.$emit('loaded', { ...data })
    },
    async reload() {
      if (!this.sendSampleCode) return
      const data = await this.$api
        .customerSendSampleDetailApi({ sendSampleCode: this.sendSampleCode })
        .then((res) => res.body)
        .catch(() => null)
      if (!data) return

      this.formData.totalQty = data.totalQty
      // this.formData.totalCtnQty = data.totalCtnQty
      // this.formData.totalWeight = data.totalWeight
      // this.formData.totalVolume = data.totalVolume
      // this.formData.freightFee = data.freightFee
      // this.formData.insurance = data.insurance
      // this.formData.totalAmount = data.totalAmount
      this.$emit('loaded', data)
    },
    async custChange(custCode) {
      if (!custCode) return

      const res = await this.$api
        .masterCustomerContactsListApi({ custCode })
        .catch(() => null)
      if (!res) return

      const data = res.body.data

      if (!data?.length) return
      if (data.length > 1) return (this.chooseCustomerContactsVisible = true)

      this.customerContactsConfirm(data[0])
    },
    async custContactChange(custCode) {
      if (!custCode) return
      const res = await this.$api
        .masterCustomerContactsListApi({ custCode })
        .catch(() => null)
      if (!res) return
      const data = res.body.data
      if (!data?.length) return
      if (data.length > 0) return (this.chooseCustomerContactsVisible = true)
    },
    customerContactsConfirm(data) {
      this.formData.custContact = data.contactName
      this.formData.custContactPhone = data.contactMobile
      this.formData.custContactEmail = data.contactEmail
    },
    async save() {
      const samples = this.sampleData.map((e) => {
        let fabricDesc = ''
        if ('N' === e.isFabricPosition) {
          fabricDesc = e.faceFabric
        } else {
          const faceFabric = e.faceFabric
            ? `${this.$l('form_label_faceFabricEn') || 'Face'}: ${e.faceFabric}`
            : ''
          const backFabric = e.backFabric
            ? `${this.$l('form_label_backFabricEn') || 'Back'}: ${e.backFabric}`
            : ''
          const innerFabric = e.innerFabric
            ? `${this.$l('form_label_innerFabricEn') || 'Middle'}: ${
                e.innerFabric
              }`
            : ''
          fabricDesc = [faceFabric, innerFabric, backFabric]
            .filter(Boolean)
            .join(`\n`)
        }
        return {
          ...e,
          qty: 1,
          defaultImageCode: e.displayImageCode,
          defaultImageUrl: e.displayImageUrl,
          goodsSizeSpec: e.expoSampleSpec || '',
          fabricDesc,
        }
      })
      this.formData.samples = samples
      if (this.loadingOpen()) return
      const res = await this.$api
        .customerSendSampleSaveApi(this.formData)
        .catch(() => null)
      this.loadingClose()

      if (!res) return
      const { status, body } = res
      if (status !== 200 || !body) {
        this.$message.error(this.$l('tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('tips_save_ok') || '保存成功！',
        type: 'success',
      })

      if (this.sendSampleCode && !this.isCopy) return this.getData()

      const { sendSampleCode, sendSampleNo } = body
      this.$router.replace({
        name: 'customerManage-sendSample-detail',
        params: { sendSampleCode, pageType: 'edit' },
        query: { sendSampleNo },
      })
    },
    async saveCheck() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      if (this.sendSampleCode) {
        if (this.loadingOpen()) return
        const res = await this.$api
          .customerSendSampleCheckCustApi({
            ...this.formData,
          })
          .catch(() => null)
        this.loadingClose()
        const checkResult = res?.body?.checkResult || 201
        if (checkResult == 200) {
          await this.save()
        } else {
          const confirm = await this.$confirm(
            this.$l('tips_change_cust_save') ||
              '当前客户被已修改，是否保存？保存后会清空已选的样品！',
            this.$l('label_completeDesc') || '确认信息',
            {
              confirmButtonText: this.$l('product_dialog_btn_confirm'),
              cancelButtonText: this.$l('btn_cancel'),
              type: 'warning',
            }
          )
            .then(() => true)
            .catch(() => false)
          if (!confirm) return
          await this.save()
        }
      } else {
        await this.save()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-input-number .el-input__inner {
    text-align: start;
  }
}
</style>
